import PropTypes from 'prop-types';

const Definitions = ({items}) => {
    return (
        <div className="Definitions">
            {items.map(item => {
                const term = item.getName();

                return (
                    <div key={term} className="Definitions-item">
                        <h2 className="heading-sm">{term}</h2>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: item.getDefinition(),
                            }}
                        />
                    </div>
                );
            })}
        </div>
    );
};

Definitions.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Definitions;
